import React from 'react';
import styled from 'styled-components';

import { Button } from '../../../../styleguide';
import { useTheme } from '../../../../hooks';
import { SPACING } from '../../../../styles/constants';
import { PlusIcon } from '../../../../styleguide/icons';

const EmptyButtonWrapper = styled.div`
  margin: ${SPACING[200]};
`;

const NewItemButton = props => {
  const { onClick, label, minimal, ...rest } = props;
  const theme = useTheme();

  return (
    <EmptyButtonWrapper>
      <Button
        minimal={minimal}
        small
        primary
        onClick={onClick}
        startIcon={<PlusIcon color={theme.white} size="24px" />}
        {...rest}
      >
        {label}
      </Button>
    </EmptyButtonWrapper>
  );
};

export default NewItemButton;
